module.exports = __webpack_public_path__ + "img/9diamante.1d495bb1.png";